import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { SubsectionTopicsComponent } from './topics/subsection-topics.component';
import { SubsectionExplorerComponent } from './subsection-explorer/subsection-explorer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '../sub-modules/SharedModule';
import { OldMediaPlayerModule } from '../shared/components/media-player/old-media-player.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { SubsectionOptionsComponent } from './options/subsection-options.component';
import { SubsectionPreviewComponent } from './preview/subsection-preview.component';
import { TopicRenameComponentComponent } from './topics/rename/topic-rename.component';
import { TopicDeleteComponentComponent } from './topics/delete/topic-delete.component';
import { SubsectionOptionsGridItemComponent } from './options/grid-item/subsection-options-grid-item.component';
import { SubsectionOptionEditComponent } from './options/edit/subsection-option-edit.component';
import { NewFilesFilterPipe } from './options/new-files-filter.pipe';
import { QuillModule } from 'ngx-quill';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FileDeleteModalComponent } from './files/delete/file-delete-modal.component';
import { SubsectionCompareComponent } from '../layouts/work/subsection/subsection-compare/subsection-compare.component';
import { VersionsComparerComponent } from '../shared/components/versions-comparer/versions-comparer.component';
import { SubsectionAddFileModalComponent } from './files/add/add-file-modal.component';
import { SubsectionFileGridItemComponent } from './files/grid-item/subsection-file-grid-item.component';
import { SubsectionMoveFileModalComponent } from './files/move/move-file-modal.component';
import { SubsectionLocationPicker } from './location-picker/location-picker.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SubsectionFileListComponent } from './files/list/subsection-file-list.component';
import { SubsectionExplorerIconComponent } from './subsection-explorer/subsection-explorer-icon/subsection-explorer-icon.component';
import { CommentThreadComponent } from './comment-thread/comment-thread.component';
import { CommentItemComponent } from './comment-thread/comment-item/comment-item.component';
import { MoreIconComponent } from './svg/more-icon/more-icon.component';
import { LeaveCommentComponent } from './leave-comment/leave-comment.component';
import { HighlightIconComponent } from './svg/highlight-icon/highlight-icon.component';
import { FormatIconComponent } from './svg/format-icon/format-icon.component';
import { AttachFileIconComponent } from './svg/attach-file-icon/attach-file-icon.component';
import { EmotionIconComponent } from './svg/emotion-icon/emotion-icon.component';
import { SendIconComponent } from './svg/send-icon/send-icon.component';
import { ThinkingIconComponent } from './svg/thinking-icon/thinking-icon.component';
import { BackIconComponent } from './svg/back-icon/back-icon.component';
import { ArrowPointIconComponent } from './svg/arrow-point-icon/arrow-point-icon.component';
import { ArrowDrawingIconComponent } from './svg/arrow-drawing-icon/arrow-drawing-icon.component';
import { CircleIconComponent } from './svg/circle-icon/circle-icon.component';
import { RectIconComponent } from './svg/rect-icon/rect-icon.component';
import { SeparatorIconComponent } from './svg/separator-icon/separator-icon.component';
import { YellowCircleIconComponent } from './svg/yellow-circle-icon/yellow-circle-icon.component';
import { RedCircleIconComponent } from './svg/red-circle-icon/red-circle-icon.component';
import { BlueCircleIconComponent } from './svg/blue-circle-icon/blue-circle-icon.component';
import { GreenCircleIconComponent } from './svg/green-circle-icon/green-circle-icon.component';
import { UndoIconComponent } from './svg/undo-icon/undo-icon.component';
import { RedoIconComponent } from './svg/redo-icon/redo-icon.component';
import { DeleteIconComponent } from './svg/delete-icon/delete-icon.component';
import { RemoveStyleIconComponent } from './svg/remove-style-icon/remove-style-icon.component';
import { BoldIconComponent } from './svg/bold-icon/bold-icon.component';
import { ItalicIconComponent } from './svg/italic-icon/italic-icon.component';
import { UnderlineIconComponent } from './svg/underline-icon/underline-icon.component';
import { StrikethroughIconComponent } from './svg/strikethrough-icon/strikethrough-icon.component';
import { TextColorIconComponent } from './svg/text-color-icon/text-color-icon.component';
import { UnorderedListIconComponent } from './svg/unordered-list-icon/unordered-list-icon.component';
import { LinkIconComponent } from './svg/link-icon/link-icon.component';
import { ArrowBackIconComponent } from './svg/arrow-back-icon/arrow-back-icon.component';
import { PrivateCommentTypeIconComponent } from './svg/private-comment-type-icon/private-comment-type-icon.component';
import { PublicCommentTypeIconComponent } from './svg/public-comment-type-icon/public-comment-type-icon.component';
import { TimeRangeRightArrowIconComponent } from './svg/time-range-right-arrow-icon/time-range-right-arrow-icon.component';
import { ReplyIconComponent } from './svg/reply-icon/reply-icon.component';
import { EditIconComponent } from './svg/edit-icon/edit-icon.component';
import { RemoveIconComponent } from './svg/remove-icon/remove-icon.component';
import { CopyLinkIconComponent } from './svg/copy-link-icon/copy-link-icon.component';
import { CommentFileComponent } from './comment-thread/comment-file/comment-file.component';
import { BinaryIconComponent } from './svg/binary-icon/binary-icon.component';
import { EyeIconComponent } from './svg/eye-icon/eye-icon.component';

import { SubsectionPageListComponent } from './pages/grid/subsection-page-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SubsectionKpfFilesComponent } from './kpf/files/subsection-kpf-files.component';
import { SubsectionKpfPreviewComponent } from './kpf/preview/subsection-kpf-preview.component';
import { KpfFolderDeleteComponent } from './kpf/delete-folder/kpf-folder-delete.component';
import { KpfFolderCreateComponent } from './kpf/create-folder/kpf-folder-create.component';
import { KpfExplorerComponent } from './subsection-explorer/kpf-explorer/kpf-explorer.component';
import { TimeInputComponent } from '../shared/components/time-input/time-input.component';

import { ShareLinkExplorerComponent } from './subsection-explorer/share-link-explorer/share-link-explorer.component';
import { SubsectionShareLinkGridComponent } from './share-link/grid/share-link-grid.component';
import { SubsectionShareLinkEditComponent } from './share-link/edit/share-link-edit.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { CdkMenuModule } from '@angular/cdk/menu';
import { SubsectionShareLinkAssetComponent } from './share-link/asset/share-link-asset.component';
import { SubsectionTreeExplorerComponent } from './subsection-explorer/subsection/subsection-tree-explorer.component';
import { SubsectionNodeComponent } from './subsection-explorer/subsection/nodes/subsection-node/subsection-node.component';
import { TopicNodeComponent } from './subsection-explorer/subsection/nodes/topic-node/topic-node.component';
import { OptionNodeComponent } from './subsection-explorer/subsection/nodes/option-node/option-node.component';
import { VersionNodeComponent } from './subsection-explorer/subsection/nodes/version-node/version-node.component';
import { FileNodeComponent } from './subsection-explorer/subsection/nodes/file-node/file-node.component';
import { ProjectNodeComponent } from './subsection-explorer/subsection/nodes/project-node/project-node.component';
import { SectionNodeComponent } from './subsection-explorer/subsection/nodes/section-node/section-node.component';
import { ShareLinkMenuComponent } from './subsection-explorer/subsection/nodes/share-link-menu/share-link-menu.component';
import { ReleaseMenuComponent } from './subsection-explorer/subsection/nodes/release-menu/release-menu.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ShareLinkThumbnailComponent } from './share-link/asset/share-link-thumbnail/share-link-thumbnail.component';
import { ReviewLinkSendMailComponent } from './share-link/edit/send-mail/send-mail.component';
import { NodeDragDirective } from './directives/node-drag.directive';
import { ShareAssetsPreviewComponent } from './share-link/share-assets/share-assets-preview.component';
import { SharePreviewExplorerComponent } from './subsection-explorer/share-preview-explorer/share-preview-explorer.component';
import { TreeGridViewComponent } from './tree-views/grid/tree-grid-view.component';
import { AgGridModule } from 'ag-grid-angular';
import { ActionsCellRendererComponent } from './topics/cell-renderers/actions-cell-renderer.component';
import { TitleCellRendererComponent } from './topics/cell-renderers/title-cell-renderer.component';
import { FileActionsCellRendererComponent } from './files/list/cell-renderers/file-actions-cell-renderer.component';
import { KpfFileActionsCellRendererComponent } from './kpf/files/cell-renderers/kpf-file-actions-cell-renderer.component';
import { SubsectionFileNameCellRendererComponent } from './files/list/cell-renderers/file-name-cell-renderer.component';
import { KpfFileNameCellRendererComponent } from './kpf/files/cell-renderers/kpf-file-name-cell-renderer.component';
import { CreatorCellRendererComponent } from './share-link/grid/cell-renderers/creator-cell-renderer.component';
import { ShareLinkActionsCellRendererComponent } from './share-link/grid/cell-renderers/actions-cell-renderer.component';
import { VersionActionsCellRendererComponent } from './options/cell-renderers/version-actions-cell-renderer.component';
import { OptionsActionsCellRendererComponent } from './options/cell-renderers/actions-cell-renderer.component';
import { ShareLinkTitleCellRendererComponent } from './share-link/grid/cell-renderers/title-cell-renderer.component';
import { ReleaseTreeExplorer } from './subsection-explorer/release/release-tree-explorer.component';
import { ReleaseGridComponent } from './release/grid/release-grid.component';
import { ReleaseEditComponent } from './release/edit/release-edit.component';
import { ReleaseEditFormComponent } from './release/edit/form/release-edit-form.component';
import { ReleaseSaveNotifyComponent } from './release/edit/release-save-notify/release-save-notify.component';
import { CreateReleaseAssetComponent } from './release/edit/create-asset/create-release-asset.component';
import { ReleaseAssetItemComponent } from './release/edit/asset/release-asset-item.component';
import { ReleasePreviewComponent } from './release/preview/release-preview.component';
import { ReleaseMoveFileModalComponent } from './release/move/release-move-file-modal.component';
import { ReleaseLocationPicker } from './release/location-picker/release-location-picker.component';
import { SubsectionAssetPickerComponent } from './asset-picker/subsection-asset-picker.component';
import { AssetsApprovalComponent } from './approval/assets-approval.component';
import { ConfirmationService, ConversationInterfaceComponent } from '@mtm/conversation-ui-angular';
import { NotificationConfirmationAdapter } from '../shared/services/notification-confirmation-adapter.service';
import { OldLeaveCommentComponent } from './old-leave-comment/old-leave-comment.component';
import { SubsectionShareDropdownComponent } from './subsection-explorer/share-dropdown/subsection-share-dropdown.component';
import { MediaPlayerComponent } from '../shared/components/media-player/media-player.component';
import { ConversationThreadHighlightDirective } from '../shared/directives/conversation-thread-highlight.directive';
import { CompareTreeExplorerComponent } from '../shared/components/compare-tree-explorer/compare-tree-explorer.component';
import { LoadingSpinnerComponent } from '../shared/components/loading-spinner/loading-spinner.component';

@NgModule({
  declarations: [
    SubsectionCompareComponent,
    SubsectionTopicsComponent,
    SubsectionOptionsComponent,
    SubsectionPreviewComponent,
    ConversationThreadHighlightDirective,
    SubsectionExplorerComponent,
    SubsectionExplorerIconComponent,
    TopicRenameComponentComponent,
    TopicDeleteComponentComponent,
    SubsectionOptionsGridItemComponent,
    SubsectionOptionEditComponent,
    VersionsComparerComponent,
    FileDeleteModalComponent,
    SubsectionAddFileModalComponent,
    SubsectionFileGridItemComponent,
    SubsectionMoveFileModalComponent,
    SubsectionFileListComponent,
    SubsectionPageListComponent,
    SubsectionLocationPicker,
    NewFilesFilterPipe,
    CommentThreadComponent,
    CommentItemComponent,
    MoreIconComponent,
    LeaveCommentComponent,
    OldLeaveCommentComponent,
    TimeInputComponent,
    HighlightIconComponent,
    FormatIconComponent,
    AttachFileIconComponent,
    EmotionIconComponent,
    SendIconComponent,
    ThinkingIconComponent,
    BackIconComponent,
    ArrowPointIconComponent,
    ArrowDrawingIconComponent,
    CircleIconComponent,
    RectIconComponent,
    SeparatorIconComponent,
    YellowCircleIconComponent,
    RedCircleIconComponent,
    BlueCircleIconComponent,
    GreenCircleIconComponent,
    UndoIconComponent,
    RedoIconComponent,
    DeleteIconComponent,
    RemoveStyleIconComponent,
    BoldIconComponent,
    ItalicIconComponent,
    UnderlineIconComponent,
    StrikethroughIconComponent,
    TextColorIconComponent,
    UnorderedListIconComponent,
    LinkIconComponent,
    ArrowBackIconComponent,
    PrivateCommentTypeIconComponent,
    PublicCommentTypeIconComponent,
    TimeRangeRightArrowIconComponent,
    ReplyIconComponent,
    EditIconComponent,
    RemoveIconComponent,
    CopyLinkIconComponent,
    CommentFileComponent,
    BinaryIconComponent,
    EyeIconComponent,
    SubsectionKpfFilesComponent,
    SubsectionKpfPreviewComponent,
    KpfFolderDeleteComponent,
    KpfFolderCreateComponent,
    KpfExplorerComponent,
    ShareLinkExplorerComponent,
    SubsectionShareLinkGridComponent,
    SubsectionShareLinkEditComponent,
    ReviewLinkSendMailComponent,
    SubsectionShareLinkAssetComponent,
    SubsectionTreeExplorerComponent,
    SubsectionNodeComponent,
    TopicNodeComponent,
    OptionNodeComponent,
    VersionNodeComponent,
    FileNodeComponent,
    ProjectNodeComponent,
    SectionNodeComponent,
    ShareLinkMenuComponent,
    ReleaseMenuComponent,
    ShareLinkThumbnailComponent,
    ShareAssetsPreviewComponent,
    SharePreviewExplorerComponent,
    NodeDragDirective,
    TreeGridViewComponent,
    ActionsCellRendererComponent,
    TitleCellRendererComponent,
    FileActionsCellRendererComponent,
    KpfFileActionsCellRendererComponent,
    SubsectionFileNameCellRendererComponent,
    KpfFileNameCellRendererComponent,
    CreatorCellRendererComponent,
    ShareLinkActionsCellRendererComponent,
    OptionsActionsCellRendererComponent,
    VersionActionsCellRendererComponent,
    ShareLinkTitleCellRendererComponent,
    ReleaseTreeExplorer,
    ReleaseGridComponent,
    ReleaseEditComponent,
    ReleaseEditFormComponent,
    ReleaseSaveNotifyComponent,
    CreateReleaseAssetComponent,
    ReleaseAssetItemComponent,
    ReleasePreviewComponent,
    ReleaseMoveFileModalComponent,
    ReleaseLocationPicker,
    SubsectionAssetPickerComponent,
    AssetsApprovalComponent,
    SubsectionShareDropdownComponent,
    CompareTreeExplorerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [
    SubsectionCompareComponent,
    SubsectionTopicsComponent,
    SubsectionOptionsComponent,
    SubsectionPreviewComponent,
    SubsectionExplorerComponent,
    SubsectionExplorerIconComponent,
    TopicRenameComponentComponent,
    TopicDeleteComponentComponent,
    SubsectionOptionsGridItemComponent,
    SubsectionOptionEditComponent,
    OldLeaveCommentComponent,
    NewFilesFilterPipe,
    VersionsComparerComponent,
    FileDeleteModalComponent,
    SubsectionFileGridItemComponent,
    SubsectionAddFileModalComponent,
    SubsectionMoveFileModalComponent,
    SubsectionFileListComponent,
    SubsectionLocationPicker,
    CommentThreadComponent,
    CommentItemComponent,
    MoreIconComponent,
    LeaveCommentComponent,
    HighlightIconComponent,
    FormatIconComponent,
    AttachFileIconComponent,
    EmotionIconComponent,
    SendIconComponent,
    ThinkingIconComponent,
    BackIconComponent,
    ArrowPointIconComponent,
    ArrowDrawingIconComponent,
    CircleIconComponent,
    RectIconComponent,
    SeparatorIconComponent,
    YellowCircleIconComponent,
    RedCircleIconComponent,
    BlueCircleIconComponent,
    GreenCircleIconComponent,
    UndoIconComponent,
    RedoIconComponent,
    DeleteIconComponent,
    RemoveStyleIconComponent,
    BoldIconComponent,
    ItalicIconComponent,
    UnderlineIconComponent,
    StrikethroughIconComponent,
    TextColorIconComponent,
    UnorderedListIconComponent,
    LinkIconComponent,
    ArrowBackIconComponent,
    PrivateCommentTypeIconComponent,
    PublicCommentTypeIconComponent,
    TimeRangeRightArrowIconComponent,
    ReplyIconComponent,
    EditIconComponent,
    RemoveIconComponent,
    CopyLinkIconComponent,
    SubsectionPageListComponent,
    CommentFileComponent,
    BinaryIconComponent,
    EyeIconComponent,
    SubsectionKpfFilesComponent,
    SubsectionKpfPreviewComponent,
    KpfFolderDeleteComponent,
    KpfFolderCreateComponent,
    KpfExplorerComponent,
    ShareLinkExplorerComponent,
    SubsectionShareLinkGridComponent,
    SubsectionShareLinkEditComponent,
    ReviewLinkSendMailComponent,
    SubsectionShareLinkAssetComponent,
    SubsectionTreeExplorerComponent,
    SubsectionNodeComponent,
    TopicNodeComponent,
    OptionNodeComponent,
    VersionNodeComponent,
    FileNodeComponent,
    ProjectNodeComponent,
    SectionNodeComponent,
    ShareLinkMenuComponent,
    ReleaseMenuComponent,
    ShareLinkThumbnailComponent,
    ShareAssetsPreviewComponent,
    SharePreviewExplorerComponent,
    NodeDragDirective,
    TreeGridViewComponent,
    ActionsCellRendererComponent,
    TitleCellRendererComponent,
    FileActionsCellRendererComponent,
    KpfFileActionsCellRendererComponent,
    SubsectionFileNameCellRendererComponent,
    KpfFileNameCellRendererComponent,
    CreatorCellRendererComponent,
    ShareLinkActionsCellRendererComponent,
    OptionsActionsCellRendererComponent,
    VersionActionsCellRendererComponent,
    ShareLinkTitleCellRendererComponent,
    ReleaseTreeExplorer,
    ReleaseGridComponent,
    ReleaseEditComponent,
    ReleaseEditFormComponent,
    ReleaseSaveNotifyComponent,
    CreateReleaseAssetComponent,
    ReleaseAssetItemComponent,
    ReleasePreviewComponent,
    ReleaseMoveFileModalComponent,
    ReleaseLocationPicker,
    SubsectionAssetPickerComponent,
    AssetsApprovalComponent,
    SubsectionShareDropdownComponent,
    CompareTreeExplorerComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CommonModule,
    SharedModule,
    OldMediaPlayerModule,
    NgSelectModule,
    QuillModule,
    PickerComponent,
    NgxSliderModule,
    NgxSkeletonLoaderModule,
    ScrollingModule,
    UiSwitchModule,
    CdkMenuModule,
    DragDropModule,
    AgGridModule,
    NgOptimizedImage,
    ConversationInterfaceComponent,
    LoadingSpinnerComponent,
  ],
  providers: [
    NewFilesFilterPipe,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ConfirmationService,
      useClass: NotificationConfirmationAdapter,
    },
    MediaPlayerComponent,
  ],
})
export class ProjectSubsectionSharedModule {}
